import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, Container } from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';

function FormVehicleService({ idService, callback }) {
  const [id, setId] = useState(idService);
  const [listForms, setInfoForms] = useState([]);
  const [infoForm, setForm] = useState({
    code: '',
    name: '',
    description: '',
    state: true,
    formsInspection: [],
    generates_email: false,
    email_message: '',
    email_recipients: '',
    certification_level: 'NONE',
  });

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const handleFormSelect = ({ target }) => {
    const value = parseInt(target.name);
    const arrayForm = infoForm.formsInspection;
    if (target.checked) {
      arrayForm.push(value);
    } else {
      const control = arrayForm.findIndex((element) => element === value);
      if (control >= 0) arrayForm.splice(control, 1);
    }
    setForm({ ...infoForm, formsInspection: arrayForm });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm };
    if (id && id !== '0') {
      respo = await put('/peritaje/service/modify/' + id, body);
      msg = 'Servicio editado Correctamente';
    } else {
      respo = await post('/peritaje/service/create/', body);
      msg = 'Servicio Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
      setId(respo.data.id);
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    callback({ type: variant, message: msg });
  };

  const validCheckedVehicle = (id) => {
    if (infoForm.formsInspection?.length > 0) {
      const valid =
        infoForm.formsInspection.findIndex((element) => element === id) >= 0
          ? true
          : false;
      return valid;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const getFormularios = async () => {
      const resForms = await get('/peritaje/forms/', {});
      if (resForms.success) {
        setInfoForms(resForms.data);
      } else {
        callback({ type: 'danger', message: resForms.message });
      }
    };

    const getService = async () => {
      if (id && id !== '0') {
        const resService = await get('/peritaje/service/' + id, {});
        if (resService.success) {
          setForm(resService.data);
        } else {
          callback({ type: 'danger', message: resService.message });
        }
      }
    };

    getFormularios();
    getService();
  }, [callback, id]);

  return (
    <Fragment>
      <Container className="m-3">
        <Form.Label htmlFor="nombre">Nombre</Form.Label>
        <Form.Control
          name="name"
          value={infoForm.name}
          onChange={(e) => handleForm(e)}
          type="text"
        />
        <Form.Label htmlFor="codigo">Codigo</Form.Label>
        <Form.Control
          name="code"
          value={infoForm.code}
          onChange={(e) => handleForm(e)}
          type="text"
        />
        <Form.Label htmlFor="description">description</Form.Label>
        <Form.Control
          name="description"
          value={infoForm.description}
          onChange={(e) => handleForm(e)}
          type="text"
        />
        <Form.Label htmlFor="certification_level" className="mt-3">
          Certificacion vehicular
        </Form.Label>
        <Form.Select
          name="certification_level"
          value={infoForm.certification_level || 'NONE'}
          onChange={(e) => handleForm(e)}
          aria-label="Certificacion vehicular"
        >
          <option value="NONE">Sin certificacion</option>
          <option value="BASIC">Basica</option>
          <option value="PLUS">Plus</option>
          <option value="PLUS_PA">Plus + propietarios anteriores</option>
        </Form.Select>
        <Form.Text className="text-muted">
          Define que se consulta en cada peritaje de este tipo. En{' '}
          <strong>Sin certificacion</strong> el boton de consulta no aparece.
        </Form.Text>
        <Form.Check
          type="switch"
          id="generates_email"
          name="generates_email"
          label="Genera correo electrónico"
          checked={infoForm.generates_email}
          onChange={(e) => handleForm(e)}
          className="mt-3"
        />
        {infoForm.generates_email && (
          <>
            <Form.Label htmlFor="email_message" className="mt-3">Mensaje de correo</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="email_message"
              value={infoForm.email_message}
              onChange={(e) => handleForm(e)}
            />
            <Form.Label htmlFor="email_recipients" className="mt-3">Destinatarios</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="email_recipients"
              value={infoForm.email_recipients}
              onChange={(e) => handleForm(e)}
            />
            <Form.Text className="text-muted">
              Listado de correos separados por coma
            </Form.Text>
          </>
        )}
      </Container>
      <Container className="m-3">
        <Row className="mt-3">Listado Formulario Habilitados</Row>
        <Row className="mt-3">
          {listForms.map((element, i) => {
            return (
              <Col lg={3} sm={12} md={6}>
                <Form.Check
                  key={i}
                  type="switch"
                  id={element.id}
                  name={element.id}
                  label={element.name}
                  checked={validCheckedVehicle(element.id)}
                  onChange={(e) => handleFormSelect(e)}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
      <Container className="text-center mt-3">
        <Row className="text-center m-3">
          <Col>
            <Button variant="secondary">Limpiar Formulario</Button>
          </Col>
          <Col>
            <Button
              type="submit"
              variant="primary"
              onClick={(e) => saveForm(e)}
            >
              Guardar Informacion
            </Button>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default FormVehicleService;
